{
	"common": {
		"save": "Zapisz",
		"skip": "Pomiń",
		"back": "Wstecz",
		"cancel": "Anuluj",
		"create-new": "Stwórz nowy",
		"and-others_one": "i {{count}} inny",
		"and-others_few": "i {{count}} innych",
		"and-others_many": "i {{count}} innych"
	},
	"settings": "Ustawienia",
	"my-organisations": "Moje organizacje",
	"my-role": "Moja rola:",
	"organisation-not-found": "Nie znaleziono organizacji",
	"tab-label-caregivers": "Opiekunowie",
	"tab-label-care-recipients": "Odbiorcy opieki",
	"tab-label-archived": "Zarchiwizowane",
	"tab-label-temporary-access": "Dostęp tymczasowy",
	"toasts": {
		"success": {
			"role-updated": "Rola zaktualizowana",
			"member-archived": "Użytkownik zarchiwizowany",
			"caregivers-assigned": "Przydzielono opiekunów",
			"care-recipient-created": "Utworzono wychowanka",
			"employee-created": "Pracownik został utworzony",
			"profile-saved": "Profil został zapisany",
			"reset-password-mail-sent": "Link do resetowania hasła przesłany e-mailem",
			"team-created": "Zespół został utworzony",
			"teams-assigned": "Przydzielono zespoły",
			"members-added-to-team": "Członkowie zostali dodani do zespołu",
			"member-removed-from-team": "Członek został usunięty z zespołu",
			"team-updated": "Zespół został zaktualizowany",
			"invitation-accept-title": "Zaakceptowano",
			"invitation-accept-content": "Pomyślnie zaakceptowano prośbę o połączenie",
			"invitation-reject-title": "Odrzucono",
			"invitation-reject-content": "Odrzuciłeś prośbę o połączenie",
			"organization-updated": "Organizacja została zaktualizowana",
			"temporary-access-invite-sent": "Zaproszenie do tymczasowego dostępu zostało wysłane",
			"temporary-access-revoked": "Dostęp tymczasowy został cofnięty",
			"member-restored": "Członek przywrócony",
			"family-caregiver-disconnected": "Opiekun rodzinny został odłączony"
		},
		"error": {
			"something-wrong": "Coś poszło nie tak",
			"no-care-recipients-selected": "Nie wybrano odbiorców opieki"
		}
	},
	"table": {
		"header": {
			"username": "Nazwa użytkownika",
			"role": "Rola",
			"email": "E-mail",
			"name": "Nazwa",
			"requester": "Zapraszający",
			"care-recipient": "Wychowanek",
			"access-end-date": "Data zakończenia dostępu"
		},
		"actions": {
			"edit": "Edytować",
			"archive": "Archiwizuj",
			"unarchive": "Cofnij archiwizację",
			"assign-caregiver": "Przypisz opiekuna",
			"reset-password": "Zresetuj hasło",
			"assign-to-teams": "Przypisz do zespołów",
			"remove-from-team": "Usuń z zespołu",
			"invite-family-member": "Zaproś członka rodziny",
			"view-profile": "Zobacz profil",
			"accept": "Zaakceptuj",
			"reject": "Odrzuć",
			"temporary-access": "Dostęp tymczasowy",
			"revoke-access": "Odwołaj dostęp",
			"deny-pletly-access": "Odmów dostępu Pletly"
		}
	},
	"new-employee": "Nowy pracownik",
	"assign": "Przypisz",
	"assign-caregivers-to": "Przypisz opiekunów do {{name}}",
	"inputs": {
		"organization-name": "Nazwa organizacji"
	},
	"create-account-for-employee": "Utwórz konto dla pracownika",
	"create-account-for-care-recipient": "Utwórz konto dla wychowanka",
	"care-recipient-created-confirmation": {
		"subtitle": "Czy chcesz podać więcej szczegółów na temat swojego podopiecznego, aby pomóc innym Opiekunom lepiej zrozumieć ich potrzeby?",
		"secondaryButton": "Przypisz opiekunów",
		"ctaButton": "Dodaj informacje",
		"title": "Pomyślnie utworzyłeś konto dla {{name}}"
	},
	"fill-care-recipient-information": {
		"title": "Dodaj informacje o Wychowanku"
	},
	"fill-information-confirmation": {
		"ctaButton": "Przypisz opiekunów",
		"subtitle": "Możesz przypisać opiekunów do: {{name}}",
		"title": "Dziękujemy!\nDodatkowe informacje są zawsze pomocne!"
	},
	"teams": {
		"new-team": "Nowy zespół",
		"form": {
			"label-name": "Nazwa zespołu",
			"label-posts-screening": "Przeglądanie postów",
			"post-screening-disabled-info": "Aby zmienić to ustawienie, wymagany jest co najmniej jeden administrator zespołu"
		},
		"teams": "Zespoły",
		"team-not-found": "Nie znaleziono zespołu",
		"no-teams-yet": "Nie utworzono jeszcze żadnych zespołów.",
		"edit-team": "Edytuj zespół",
		"other-teams": "Inne zespoły",
		"no-other-teams-created": "Nie utworzono żadnych innych zespołów.",
		"new-sub-team": "Nowy podzespół",
		"delete": {
			"are-you-sure-you-want-to-delete-the-name-team": "Czy na pewno chcesz usunąć zespół {{ name }}?",
			"team-deleted": "Zespół usunięty",
			"this-will-also-remove-its-sub-teams-if-any": "To również usunie jego zagnieżdżone zespoły.",
			"delete-team": "Usuń zespół",
			"if-you-want-also-to-disconnect-caregivers-or-care-recipients-inside-team-please-do-so-first": "Jeśli chcesz również odłączyć opiekunów lub opiekunów w zespole, zrób to najpierw.",
			"label-description": "Ta akcja usunie zespół i nie można jej cofnąć."
		},
		"help-content": "Zespoły w Pletly pozwalają łatwiej zarządzać dostępem opiekunów. \nGdy dodasz opiekuna do zespołu, automatycznie uzyska on dostęp do wszystkich odbiorców opieki w tym zespole. \nDodaj odbiorcę opieki do zespołu, a wszyscy jego opiekunowie zostaną połączeni. \nUsuń kogoś z zespołu, a połączenie również zostanie usunięte.\n \nMożna także tworzyć podzespoły. \nOpiekunowie w zespole głównym będą nadal mieli dostęp do odbiorców opieki w podzespołach, nawet jeśli nie są tam bezpośrednio dodani."
	},
	"assign-to-teams": "Przypisz do zespołów",
	"add-caregivers-to-team": "Dodaj opiekunów do zespołu",
	"add-care-recipients-to-team": "Dodaj wychowanków do zespołu",
	"no-members-to-add": "Brak członków do dodania",
	"confirmations": {
		"remove-from-team": {
			"title": "Usunąć {{name}} z zespołu?",
			"content-caregiver": "Usunięcie Opiekuna z zespołu spowoduje jego odłączenie od wszystkich wychowanków należących do tego zespołu.",
			"content-care-recipient": "Usunięcie wychowanka z zespołu spowoduje jego odłączenie od wszystkich Opiekunów należących do tego zespołu."
		},
		"accept-invitation": {
			"title": "Zaakceptować prośbę o połączenie?",
			"content": "Czy na pewno chcesz zaakceptować prośbę użytkownika {{requesterName}} o zostanie opiekunem użytkownika {{careRecipientName}}?"
		},
		"reject-invitation": {
			"title": "Odrzucić prośbę o połączenie?",
			"content": "Czy na pewno chcesz odrzucić prośbę użytkownika {{requesterName}} o zostanie opiekunem użytkownika {{careRecipientName}}?"
		},
		"revoke-temporary-access": {
			"title": "Odwołać tymczasowy dostęp?",
			"content": "Czy na pewno chcesz odebrać użytkownikowi {{caregiverEmail}} tymczasowy dostęp do profilu użytkownika {{careRecipientName}}?"
		},
		"archive-organisation-member": {
			"title": "Archiwizuj użytkownika",
			"content": "Czy na pewno chcesz zarchiwizować {{name}}?"
		},
		"block-organisation-member-login": {
			"title": "Zabroń użytkownikowi korzystania z Pletly",
			"content": "Dostęp można włączyć później ustawiając nowe hasło. \n\n \nCzy na pewno chcesz zablokować logowanie dla {{name}}?"
		},
		"unarchive-organisation-member": {
			"content": "Czy na pewno chcesz przywrócić konto {{name}}?",
			"title": "Przywróć użytkownika"
		}
	},
	"tab-label-familycaregivers": "Opiekunowie rodzinni",
	"terms-of-use": {
		"title": "Warunki korzystania",
		"manage-terms-of-use": "Zarządzaj Warunkami użytkowania",
		"new-version": "Nowa wersja",
		"table": {
			"updated-at": "Zaktualizowano o godz",
			"members-accepted": "Członkowie przyjęci",
			"text": "Tekst"
		},
		"accepted": "Zaakceptowali",
		"terms-of-use-accepted": "Warunki użytkowania zostały zaakceptowane",
		"i-agree-to-the-terms-of-use-as-outlined-by": "Zgadzam się z Warunkami użytkowania określonymi przez",
		"members-who-accepted": "Członkowie, którzy zaakceptowali",
		"new-terms-of-use": "Nowe Warunki korzystania",
		"new-terms-of-use-field-placeholder": "Warunki korzystania",
		"terms-of-use-created": "Utworzono Warunki korzystania",
		"accept": "Zaakceptuj"
	},
	"connection-requests": {
		"title": "Prośby o połączenie",
		"view-all": "Zobacz wszystkie prośby"
	},
	"telephone": "Telefon",
	"import-care-recipient": "Importuj odbiorcę opieki",
	"enter-the-care-recipients-unique-username-to-send-an-import-request-to-the-account-owner": "Wprowadź unikalną nazwę użytkownika Opieki, aby wysłać prośbę o import do właściciela konta.",
	"request-sent": "Wniosek wysłany",
	"request-has-been-sent-to-the-care-receiver-guardian": "Prośba została wysłana do opiekuna odbiorcy opieki",
	"add-new": "Dodaj nowego",
	"create-new-care-recipient": "Utwórz nowego podopiecznego",
	"new-post": "Nowy post",
	"edit-organization": "Edytuj organizację",
	"temporary-access": {
		"title": "Dostęp tymczasowy",
		"send-invite": "Wyślij zaproszenie",
		"label-access-duration": "Czas dostępu",
		"label-custom-duration": "Czas trwania",
		"placeholder-select-care-recipients": "Wybierz odbiorców opieki",
		"label-select-care-recipients": "Wybrani odbiorcy opieki",
		"new-button": "Nowy dostęp tymczasowy"
	},
	"roles": {
		"manager": "Menedżer systemu",
		"member": "Opiekun",
		"care-recipient": "Odbiorca opieki",
		"team-admin": "Administrator zespołu"
	},
	"allow-care-recipient-to-use-pletly": "Zezwalaj odbiorcy Care na korzystanie z Pletly",
	"family-caregiver-connections-modal": {
		"title": "Połączenia opiekunów rodzinnych",
		"button-disconnect": "Odłącz",
		"confirm-disconnect": {
			"title": "Odłącz opiekuna rodzinnego",
			"content": "Czy na pewno chcesz odłączyć {{caregiverName}} i {{careRecipientName}}?"
		},
		"connections-list-empty": "Lista połączeń jest pusta"
	},
	"request-ownership": "Poproś o własność",
	"no-email": "Brak e -maila",
	"initial-password-for-first-login": "Początkowe hasło dla pierwszego logowania"
}
